import AppBarElement from './AppBar.element'

if (!window.customElements.get('app-bar')) {
  window.customElements.define('app-bar', AppBarElement)
}
